import SelectAllController from './select_all_controller'
import { Sortable } from './mixins/sortable'

export default class extends Sortable(SelectAllController) {
  static targets = ['checkboxAll', 'checkbox', 'sortableItem']

  toggle (e) {
    super.toggle(e)
    this.refresh()
  }

  refresh () {
    super.refresh()
    this.refreshRequiredValidation()
  }

  refreshRequiredValidation () {
    if (this.checkboxTargets.length === 0) return

    const lastCheckbox = this.checkboxTargets[this.checkboxTargets.length - 1]
    const hasAnyChecked = this.checked.length > 0

    this.checkboxTargets.forEach((checkbox) => {
      if (checkbox !== lastCheckbox) checkbox.required = false
    })
    lastCheckbox.required = !hasAnyChecked
  }

  onDragEnd () {
    this.refresh()
  }
}
